export default __webpack_public_path__ + "static/media/link.f2de5522.svg";